import { TApplicationState } from '../../types/referral/store';

export const selectQueryString = (state: TApplicationState) => state.page.queryString || {};

export const selectIsReferralStickyScrollBtnVisible = (state: TApplicationState) => state.page.stickyScrollBtnVisible;

export const selectIsReferralModalOpen = (state: TApplicationState) => state.page.modal.modalFormOpen;

export const selectReferralModalSource = (state: TApplicationState) => state.page.modal.modalSource;
